import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (!error) return; const t = setTimeout(() => setError(''), 5000); return () => clearTimeout(t); }, [error]);

  const checkBackendHealth = async () => {
    try {
      const response = await axios.get('/api/health', { 
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
        }
      });
      return response.status === 200;
    } catch (error) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const isBackendHealthy = await checkBackendHealth();
      if (!isBackendHealthy) {
        setError('Сервис временно недоступен. Пожалуйста, попробуйте позже.');
        setIsLoading(false);
        return;
      }

      const response = await axios.post('/api/login', {
        username,
        password
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 10000
      });

      if (response.data && response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        navigate('/dashboard');
      } else {
        setError('Неверный ответ от сервера: отсутствует токен');
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 401) {
          setError('Неверное имя пользователя или пароль. Пожалуйста, попробуйте снова.');
        } else if (err.response.status === 422) {
          setError('Ошибка валидации. Проверьте введенные данные.');
        } else if (err.response.data && err.response.data.detail) {
          setError(err.response.data.detail);
        } else {
          setError(`Ошибка сервера: ${err.response.status} - ${err.response.statusText}`);
        }
      } else if (err.request) {
        setError('Сетевая ошибка. Проверьте подключение к серверу.');
      } else {
        setError('Ошибка запроса: ' + err.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Visor-ECO</h2>
        <form onSubmit={handleSubmit}>
          {error && <div className="error">{error}</div>}
          <div className="form-group">
            <label>Имя пользователя:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
              placeholder="Введите имя пользователя"
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label>Пароль:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
              placeholder="Введите пароль"
              autoComplete="current-password"
            />
          </div>
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
